import { HOST_URL } from '../config'
import { HttpStatus } from '../constants/http-status.enum'
import type { ApiResponse } from './index'

export type MobileAppPlatform = 'android' | 'ios-adhoc'

export interface IMobileAppRelease {
    id: string
    platform: MobileAppPlatform
    fileName: string
    sizeBytes: number
    title: string
    version: string
    notes: string
    bundleId?: string
    uploadedBy?: string
    createdAt: string
    downloadUrl: string
    manifestUrl?: string
    installUrl?: string
}

function encodeHeaderValue(value: string | undefined): string {
    return encodeURIComponent(value || '')
}

export async function listMobileApps(): Promise<ApiResponse<IMobileAppRelease[]>> {
    const response = await fetch(`${HOST_URL}mobile-apps`, {
        method: 'GET',
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<IMobileAppRelease[]>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function uploadMobileApp(input: {
    platform: MobileAppPlatform
    file: File
    title?: string
    version?: string
    notes?: string
    bundleId?: string
}): Promise<ApiResponse<IMobileAppRelease>> {
    const buffer = await input.file.arrayBuffer()
    const response = await fetch(`${HOST_URL}mobile-apps/upload`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/octet-stream',
            'x-mobile-platform': encodeHeaderValue(input.platform),
            'x-mobile-file-name': encodeHeaderValue(input.file.name),
            'x-mobile-title': encodeHeaderValue(input.title),
            'x-mobile-version': encodeHeaderValue(input.version),
            'x-mobile-notes': encodeHeaderValue(input.notes),
            'x-mobile-bundle-id': encodeHeaderValue(input.bundleId),
        },
        body: buffer,
    })
    const result = (await response.json()) as ApiResponse<IMobileAppRelease>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function deleteMobileApp(id: string): Promise<ApiResponse<{ id: string }>> {
    const response = await fetch(`${HOST_URL}mobile-apps/${id}`, {
        method: 'DELETE',
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<{ id: string }>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function updateMobileAppTitle(id: string, title: string): Promise<ApiResponse<IMobileAppRelease>> {
    const response = await fetch(`${HOST_URL}mobile-apps/${id}/title`, {
        method: 'PATCH',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title }),
    })
    const result = (await response.json()) as ApiResponse<IMobileAppRelease>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
